import React,{useRef,useEffect} from 'react';
// the hook
import {useTranslation} from 'react-i18next';
import { AndroidOutlined, AppleOutlined, CommentOutlined, ThunderboltOutlined, CustomerServiceOutlined, ToolOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import {Carousel,Tabs } from 'antd';
import {history} from "../../libs";


import style from './index.module.less'
import banner1 from './banner1.jpg';
import banner2 from './banner2.png';
import banner3 from './banner3.png';
import banner4 from './banner4.png';
import logoNameImg from './logoNameImg.png';
import cart from './cart.png';
import arrowLeft from './arrowLeft.png';
import arrowRight from './arrowRight.png';
import serviceArea from './serviceArea.png';
import contactTitle from './title.png';
import contact1 from './contact1.png';
import contact2 from './contact2.png';
import contact3 from './contact3.png';


export default function () {
  const {t, i18n} = useTranslation();// {t('')}
  const carouselRef= useRef(null);

  const items = [
    {
      key: '1',
      label: <span>
        <ThunderboltOutlined />
        极速响应零距离
      </span>,
      children: `专属客服人员在“1H”内相应询报价、设备选型，提供技术问题解答、售后服务等。`,
    },
    {
      key: '2',
      label: <span>
      <CustomerServiceOutlined />
      全程服务零距离
    </span>,
      children: '全国主要城市定点医院的配送及上门回收；负责设备的防护运输、拆箱安装、测试及善后清运等',
    },
    {
      key: '3',
      label: <span>
      <ToolOutlined />
      个性定制零距离
    </span>,
      children: '应用户需求,进行仪器设备非标设计、定制',
    },
    {
      key: '4',
      label: <span>
      <CommentOutlined />
      贴心咨询零距离
    </span>,
      children: '针对采购及租赁，给用户提供成本/支出的合理建议方案',
    },
  ];

  const handleNext = ()=>{
    carouselRef.current.next();
  }
  const handlePrev = ()=>{
    carouselRef.current.prev();
  }

  return (
    <div className={style.homeContainer}>
      {
        // i18n.language === 'zh' ? (
          <Carousel  ref={carouselRef}>
            <div className={style.bannerItem}>
              <img className={style.bannerImg} src={banner1} alt="" />
              <img className={style.logoImg} src={logoNameImg} alt="" />
              <div className={style.bannerContainer}>
                <div className="content_item first_item"><h3 className='title first_title'>泉心 优选 科研 无忧</h3></div>
                <div className="content_item">
                  <h3 className='title'>简化沟通</h3>
                  <div className='desc'>针对供应渠道进行整合评估，减少用户“一对多”的频繁沟通。</div>
                </div>
                <div className="content_item">
                  <h3 className='title'>紧急响应</h3>
                  <div className='desc'>优选设备，充足备货，完善的紧急替换方案。</div>
                </div>
                <div className="content_item">
                  <h3 className='title'>暂存代发</h3>
                  <div className='desc'>提供设备托管服务，代发、代管，整体降低用户设备管理和仓储的成本。</div>
                </div>
              </div>
              <img className={style.cart} onClick={() => history.push('/cart')} src={cart} alt="" />
            </div>
            <div className={style.bannerItem}>
              <img className={style.bannerImg} src={banner2} alt="" /> 
              <div className={style.zeroContainer}>
                <div className='zero_title'>
                  <h3>“零距离”服务体系</h3>
                  <div>ZERO DISTANCE</div>
                </div>
                <Tabs
                  defaultActiveKey="1"
                  items={items.map((item, i) => {
                    return {
                      label: item.label,
                      key: item.key,
                      children: item.children,
                    };
                  })}
                />
              </div>
              <img className={style.cart} src={cart} alt="" onClick={() => history.push('/cart')} />
              {/* <img onClick={()=>handleNext()} className={style.arrow} src={arrowRight} alt="" /> */}
            </div>
            <div className={style.bannerItem}>
              <img className={style.bannerImg} src={banner3} alt="" />
              <img className={style.cart} src={cart} alt="" onClick={() => history.push('/cart')} />
              {/* <img onClick={()=>handleNext()} className={style.arrow} src={arrowRight} alt="" /> */}
              <div className={style.zeroContainer}>
                <div className='zero_title'>
                  <h3>服务范围</h3>
                  <div>SERVICE AREA</div>
                </div>
                <div className='content'>
                  <div className='left'>
                    <div className='left_title'>
                        可供租赁的临床试验常用设备采取长期备货，在主要医药园区有现货仓储，可快调拨现货至临床医药研发集群。
                    </div>
                    <div className='left_desc'>
                      <div className='desc_item'>
                        <div>北京</div>
                        <span>华北仓</span>
                      </div>
                      <div className='desc_item'>
                        <div>上海</div>
                        <span>华东仓</span>
                      </div>
                      <div className='desc_item'>
                        <div>成都</div>
                        <span>华西仓</span>
                      </div>
                      <div className='desc_item'>
                        <div>广州</div>
                        <span>华南仓</span>
                      </div>
                    </div>
                  </div>
                  <div className='right'>
                    <img src={serviceArea} alt="" />
                  </div>
                </div>
              </div> 
            </div>
            <div className={style.bannerItem}>
              <img className={style.bannerImg} src={banner4} alt="" />
              <img className={style.cart} src={cart} alt="" onClick={() => history.push('/cart')} />
              <div className={style.zeroContainer}>
                <div className='zero_title'>
                  <h3>联系我们</h3>
                  <div>CONTACT US</div>
                </div>
                <div className='contact_title'>
                  <div>临床智慧供应链服务中心</div>
                  <img src={contactTitle} alt="" />
                </div>
                <div className='content contact_content'>
                  <div className='contact_item'>
                    <img src={contact1} alt="" />
                    <div>
                      cssc@lab-direct.com
                    </div>
                  </div>
                  <div className='contact_item'>
                    <img src={contact2} alt="" />
                    <div>
                      400-086-5292
                    </div>
                  </div>
                  <div className='contact_item'>
                    <img src={contact3} alt="" />
                    <div>
                      上海浦东新区达尔路88号15号楼1-2层
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </Carousel>
      }
      <img onClick={()=>handleNext()} className={style.arrowRight} src={arrowRight} alt="" /> 
      <img onClick={()=>handlePrev()} className={style.arrowLeft} src={arrowLeft} alt="" />
    </div>
  )
}
